export default "__VITE_ASSET__Dm0hzY4R__"